import React from "react";
import { Link } from "react-router-dom";
import Video1 from "../../assets/videos/lie.mp4";
import Video2 from "../../assets/videos/life.mp4";
import Video3 from "../../assets/videos/pressure.mp4";
import Video4 from "../../assets/videos/truth.mp4";
import HomevideoComponent from "../../component/HomevideoComponent";

const Video = () => {
  return (
    <div>
      <section className="my-20 sm:px-20 px-5">
        <div className="flex items-center justify-between w-full max-w-5xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900">Short Videos</h2>
          <Link
            to="/videos"
            className="text-lg text-blue-600 hover:text-blue-800 transition-colors duration-300"
          >
            See All
          </Link>
        </div>
        <div className="sm:grid mx-auto flex items-center justify-center flex-col sm:grid-cols-1 lg:grid-cols-3 sm:gap-6  ">
          <HomevideoComponent source={Video1} likes="203" views="5,345" />
          <HomevideoComponent source={Video2} likes="203" views="5,345" />
          <HomevideoComponent source={Video3} likes="203" views="5,345" />
          <HomevideoComponent source={Video4} likes="203" views="5,345" />
        </div>
      </section>
    </div>
  );
};

export default Video;
